import React, { useContext } from 'react';
import { FaCopy, FaGift, FaShareAlt, FaUsers } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { AuthContext } from '../contexts/AuthContext';
import { useToast } from '../components/Shared/Toast';

const ReferralHub = () => {
  const { user } = useContext(AuthContext);
  const { success, error } = useToast();

  const referralCode = user?.referralCode || '';
  const referralLink = user?.referralLink || `${window.location.origin}/register?ref=${referralCode}`;

  const copyText = async (value, label) => {
    try {
      await navigator.clipboard.writeText(value);
      success('Copied', `${label} copy ho gaya.`);
    } catch (copyError) {
      error('Copy Failed', `${label} copy nahi ho saka.`);
    }
  };

  const shareReferralLink = async () => {
    if (!navigator.share) {
      copyText(referralLink, 'Referral link');
      return;
    }

    try {
      await navigator.share({
        title: 'Join Ideal11',
        text: 'Ideal11 join karo mere referral link se.',
        url: referralLink
      });
    } catch (shareError) {
      // Ignore cancel.
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="min-h-screen bg-slate-50 px-4 py-8"
    >
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <p className="text-sm font-semibold uppercase tracking-wide text-emerald-600">Referral Center</p>
          <h1 className="mt-2 text-4xl font-extrabold text-slate-900">Invite, play, and earn</h1>
          <p className="mt-3 max-w-2xl text-slate-600">
            Apna referral share karo. Referral bonus playable wallet me aata hai, aur us se jeeti hui amount withdrawable wallet me chali jati hai.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.35fr_0.9fr]">
          <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-sm font-semibold text-emerald-700">
                  <FaGift className="mr-2" /> Active Referral
                </div>
                <h2 className="mt-4 text-2xl font-bold text-slate-900">Your referral code</h2>
              </div>
              <div className="rounded-2xl bg-slate-900 px-5 py-4 text-white shadow-sm">
                <p className="text-xs uppercase tracking-[0.18em] text-slate-300">Code</p>
                <p className="mt-2 text-2xl font-extrabold">{referralCode || 'Loading'}</p>
              </div>
            </div>

            <div className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <p className="text-sm font-medium text-slate-500">Referral link</p>
              <p className="mt-2 break-all text-base font-semibold text-slate-900">{referralLink}</p>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              <button
                onClick={() => copyText(referralCode, 'Referral code')}
                className="inline-flex items-center rounded-xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
              >
                <FaCopy className="mr-2" /> Copy Code
              </button>
              <button
                onClick={() => copyText(referralLink, 'Referral link')}
                className="inline-flex items-center rounded-xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
              >
                <FaCopy className="mr-2" /> Copy Link
              </button>
              <button
                onClick={shareReferralLink}
                className="inline-flex items-center rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-100"
              >
                <FaShareAlt className="mr-2" /> Share
              </button>
            </div>
          </section>

          <aside className="space-y-6">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <div className="flex items-center text-slate-900">
                <FaUsers className="mr-3 text-emerald-600" />
                <h3 className="text-lg font-bold">Performance</h3>
              </div>
              <div className="mt-5 grid gap-4">
                <div className="rounded-xl bg-slate-50 p-4">
                  <p className="text-sm text-slate-500">Successful referrals</p>
                  <p className="mt-1 text-3xl font-extrabold text-slate-900">{user?.referralCount || 0}</p>
                </div>
                <div className="rounded-xl bg-slate-50 p-4">
                  <p className="text-sm text-slate-500">Referral bonus earned</p>
                  <p className="mt-1 text-3xl font-extrabold text-slate-900">Rs {Number(user?.referralBonusEarned || 0).toFixed(2)}</p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-gradient-to-br from-emerald-600 to-teal-700 p-6 text-white shadow-sm">
              <p className="text-sm font-semibold uppercase tracking-wide text-emerald-100">Wallet Rule</p>
              <p className="mt-3 text-lg font-semibold">Referral bonus playable hota hai.</p>
              <p className="mt-2 text-sm text-emerald-50">
                Referral balance se khel kar jo win aati hai woh withdrawable wallet me add hoti hai.
              </p>
            </div>
          </aside>
        </div>
      </div>
    </motion.div>
  );
};

export default ReferralHub;
